import { useEffect } from 'react';

/**
 * Hook that triggers a hard page refresh at midnight + 10 seconds each day.
 * This ensures the app updates to show the correct day's tasks when the date changes.
 */
export function useMidnightRefresh(): void {
  useEffect(() => {
    const scheduleRefresh = (): NodeJS.Timeout => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 10, 0); // 12:00:10 AM

      const msUntilMidnight = tomorrow.getTime() - now.getTime();

      return setTimeout(() => {
        window.location.reload();
      }, msUntilMidnight);
    };

    const timeoutId = scheduleRefresh();

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
}
